import { CopyButton as UICopyButton, type CopyButtonProps } from '@jagad/ui'
import { useTranslation } from 'react-i18next'

type Props = Omit<CopyButtonProps, 'copiedMessage'>

const CopyButton = (props: Props) => {
    const { t } = useTranslation()
    return (
        <UICopyButton
            {...props}
            copiedMessage={t('components.copyButton.copiedMessage')}
        />
    )
}

export default CopyButton
export type { CopyButtonProps }
